import Board from "./board";
import Container from "./container";
import SortableItem from "./sortable-item";
import AddColumnModal from "./add-column";
import DeleteColumnModal from "./delete-column";
import AddTaskModal from "./add-task";
import TaskDetail from "./tssk-detail";
import DeleteTaskModal from "./delete-task";
import UpdateTaskModal from "./update-task";

export {
  Board,
  Container,
  SortableItem,
  AddColumnModal,
  DeleteColumnModal,
  AddTaskModal,
  TaskDetail,
  DeleteTaskModal,
  UpdateTaskModal,
};
